var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"item"},[_c('h2',[_vm._v(_vm._s(index+1)+". "+_vm._s(item.title))]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(item.text)}})])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8b111c60","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Qa.vue
// module id = null
// module chunks = 